import React, { useState, useEffect } from "react";

import useChat from "hooks/use-chat";
import AgentsDropdown from "../agents-dropdown";

const TicketSummary = () => {
  const { ticketUserImage, userName, userRoleName, userClinic } = useChat();
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    if (!modalOpen) return;
    const handleKey = (e) => e.key === "Escape" && setModalOpen(false);
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [modalOpen]);

  const imageSrc = ticketUserImage?.attributes?.original;

  return (
    <div className="ticketSection">
      <div>
        <h3>Agent</h3>
        <AgentsDropdown />
        <h3>User</h3>
        <div className="user-summary" style={{ maxWidth: "270px" }}>
          {imageSrc && (
            <img
              src={imageSrc}
              alt="User avatar"
              className="ticket-user-avatar"
              onClick={() => setModalOpen(true)}
            />
          )}
          <div className="flexColumn">
            <span>{userName}</span>
            <span className="subtext" style={{ marginTop: "2px" }}>
              {userRoleName}
              {userClinic?.attributes?.clinic_name &&
                ` • ${userClinic.attributes.clinic_name}`}
            </span>
          </div>
        </div>
      </div>

      {modalOpen && (
        <div
          className="image-modal-overlay"
          onClick={() => setModalOpen(false)}
        >
          <img
            src={imageSrc}
            alt="User avatar"
            className="image-modal-content"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </div>
  );
};

export default TicketSummary;
